<div :class="$style.item">
  <span :class="$style.itemCounter" :idx="index"></span>
  <div
    v-if="isUploading()"
    :class="[$style.itemSpinner]">
    <animation-processing></animation-processing>
  </div>
  <div
    v-if="isComplete()"
    :class="$style.itemPicture"
    :style="pictureStyle">
  </div>
  <button
    v-if="isComplete()"
    :id="$vId(this, 'remove')"
    type="button"
    class="mt-icon"
    :class="$style.itemRemove"
    @click="remove">
  </button>
</div>
